var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#E3215F",
    transform: "translate(.405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.14225 5.44725-3.42225 3.402-3.42225-3.402-.8505.8505 3.402 3.42225-3.402 3.42225.8505.8505 3.42225-3.402 3.42225 3.402.8505-.8505-3.402-3.42225 3.402-3.42225z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.72.10125c-5.3055 0-9.61875 4.31325-9.61875 9.61875s4.31325 9.61875 9.61875 9.61875 9.61875-4.31325 9.61875-9.61875-4.31325-9.61875-9.61875-9.61875zm0 18.0225c-4.63725 0-8.40375-3.7665-8.40375-8.40375s3.7665-8.40375 8.40375-8.40375 8.40375 3.7665 8.40375 8.40375-3.7665 8.40375-8.40375 8.40375z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.c554f5d64032ab810b0f9aadefcc80b0.svg";
export { ForwardRef as ReactComponent };